import React, { useMemo } from "react";
import { Form } from "react-bootstrap";
import { Series } from "../../../../types/model";
import { RootState } from "../../../../store/store";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { setSelectedSeries } from "../../../../store/slices/fantasySlice";
import {
	getEventSeries,
	getFutureEvents,
	getSeasonEvents,
} from "../../../../utils/helper";
import { FaCaretDown } from "react-icons/fa";

const SeriesFilter = () => {
	const { selectedSeries, selectedSeason, series, events, selectedSport } = useAppSelector(
		(state: RootState) => state.fantasy,
	);
	const dispatch = useAppDispatch();

	const eventSeries = useMemo(() => {
		const seasonEvents = getSeasonEvents(events, selectedSeason._id ?? "");
		const futureEvents = getFutureEvents(seasonEvents).filter((event) =>
			selectedSport?._id ? event.sport?._id === selectedSport._id : true,
		);
		return getEventSeries(futureEvents);
	}, [events, selectedSeason._id, selectedSport?._id]);

	const handleSeriesChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const seriesId = event.target.value;
		const _selectedSeries = series.find((s: Series) => s._id === seriesId);
		if (!_selectedSeries) {
			return;
		}
		dispatch(setSelectedSeries(_selectedSeries));
	};

	return (
		<div className="fantasy-filter-select-wrap">
			<Form.Group className="mx-sm-2 rounded-pill">
				<Form.Select
					value={selectedSeries?._id}
					onChange={handleSeriesChange}
					className="fantasy-filter-select"
				>
					<option value="" disabled>
						-- Select a Series --
					</option>
					{eventSeries.map((s: Series) => (
						<option key={s._id} value={s._id}>
							{s.name.toLocaleUpperCase()}
						</option>
					))}
				</Form.Select>
			</Form.Group>
			<FaCaretDown className="fantasy-filter-select-icon" />
		</div>
	);
};

export default SeriesFilter;
